import axios from 'axios';

export const apiPriceDetail = (date) => {
    return axios.get(`/averageprice/detail?date=${date}`);
}

//取得圖表數值
export const getApiAvaragePrice = (monthFrom, monthTo) => {
    return axios.get(`/averageprice?from=${monthFrom}&to=${monthTo}`);
};

export const getApiRecommendData = async (dates) => {
    let datesstr = "dates[]=" + dates.join("&dates[]=");
    return axios.get(`/recommendprice?${datesstr}`);
};

export const getApiRecommendPriceDetail = (dates, category) => {
    let datesstr = "dates[]=" + dates.join("&dates[]=");
    return axios.get(`/recommendprice/detail?${datesstr}&roomcategory_id=${category}`);
}
/**
 * 逐日的自家績效 (住房率、ADR、RevPAR)，供價格走勢圖對照用。
 *
 * 這支是行情儀錶板專屬的契約，不要換回 ops 的端點 —— 原本接 pms/ops/pace，
 * 但那支是為了 asof 歷史還原而生的，行情這邊從來不傳 asof，卻要承受它為了
 * 營運儀表板而變動的風險。ADR 為含餐口徑 (與 OTA 抓價同基準)，理由見後端
 * PricingPerformanceController 的類別註解。
 *
 * 資料來自德安 PMS 的 Oracle，需要 VPN；行情儀錶板的價格資料則全在本地資料庫。
 * 兩者互相獨立，呼叫端要能容忍這支失敗而不影響價格走勢。
 */
export const getApiPricingPerformance = (from, to) => {
  // PMS 那側的端點一律吃 YYYY/MM/DD (見 PmsAPI.js)，傳破折號會被 normDate
  // 當成無效值而退回預設的「今天」，結果只拿得到一天
  const pms = (d) => String(d).replace(/-/g, "/");
  return axios.get(`/pms/pricing/daily-performance?from=${pms(from)}&to=${pms(to)}`);
};

/**
 * 在手住房率的「正常帶」—— 未來 8 週逐日的 P25/中位/P75 (過去 5 年同 lead time)。
 *
 * 沒有這條基準，在手住房率會一路誤導：越遠的日期數字越低，看起來永遠像落後。
 * 窗口固定 8 週、由後端決定 (見 PricingPerformanceController::BAND_DAYS)，
 * 呼叫端不必也不該傳範圍。
 *
 * 未快取要 15 秒，所以呼叫端必須非阻塞地抓，不能擋住價格走勢。
 */
export const getApiPricingPaceBand = () =>
  axios.get(`/pms/pricing/pace-band`);
